
import React, { useEffect, useState } from 'react'
import { Paragraph, SectionInfo } from 'types/Challenge'
import Typography from 'Components/Base/Typography'
import Row from 'Components/Base/Row'
import Column from 'Components/Base/Column'
import data from 'tria-ui-react-lib/challenges/stepInfo.json'
import ResponsiveContainer from 'Components/Base/ResponsiveContainer'

interface Props {
  isMobile: boolean
  step: number
  setInfoPage: (infoPage: boolean) => void

}
export default function CarbsStep3({ isMobile, step, setInfoPage }: Props) {
  const [sectionInfo, setSectionInfo] = useState<SectionInfo>()
  const [stepParagraphs, setStepParagraphs] = useState<Paragraph[]>()

  useEffect(() => {
    setInfoPage(true)
    window.scrollTo(0, 0)
    setSectionInfo(data.pageInfoBySection.sectionInfo.find((sectionInfo) => sectionInfo.sectionId === parseInt(window.location.pathname.split('/')[window.location.pathname.split('/').length - 2])))
    setStepParagraphs(data.pageInfoBySection.sectionInfo.find((sectionInfo) => sectionInfo.sectionId === parseInt(window.location.pathname.split('/')[window.location.pathname.split('/').length - 2]))?.paragraphs)
  }, [step])

  return (
    <ResponsiveContainer>
      <Column styles={{ margin: isMobile ? '20px auto' : 'auto 0px' }}>
        <Row styles={{ margin: isMobile ? '20px auto' : '20px 0px' }}>
          <Typography variant='h1'>{sectionInfo?.titles.find((title) => title.titleId === 6)?.titleText ?? ''}</Typography>
        </Row>
        <img src={sectionInfo?.images.find((image) => image.imageId === 3)?.url} alt='scale' style={{ width: isMobile ? '100%' : '494px' }} />
        <Row styles={{ margin: isMobile ? '20px auto' : '20px 0px', width: isMobile ? '100%' : '70%' }}>
          <p style={{ fontFamily: 'Raleway', fontSize: 20 }}><i>{sectionInfo?.titles.find((title) => title.titleId === 7)?.titleText ?? ''}</i> {stepParagraphs?.find((paragraph) => paragraph.paragraphId === 6)?.paragraph ?? ''}</p>
        </Row>
        <Row styles={{ margin: isMobile ? '20px auto' : '20px 0px', width: isMobile ? '100%' : '70%' }}>
          <Typography size={20}>{stepParagraphs?.find((paragraph) => paragraph.paragraphId === 7)?.paragraph ?? ''}</Typography>
        </Row>
        <Column styles={{ margin: isMobile ? '20px auto ' : '20px 0px ', width: isMobile ? '100%' : '70%' }}>
          <Typography variant='h2'>{sectionInfo?.titles.find((title) => title.titleId === 9)?.titleText ?? ''}</Typography>
          <Typography size={20}>{stepParagraphs?.find((paragraph) => paragraph.paragraphId === 8)?.paragraph ?? ''}</Typography>
        </Column>
      </Column>
      <Column styles={{ margin: isMobile ? '20px auto' : '76px 0px' }}>
        <img src={sectionInfo?.images.find((image) => image.imageId === 4)?.url} alt='scale' style={{ width: isMobile ? '100%' : '494px' }} />
        <Row styles={{ margin: isMobile ? '20px auto' : '20px 0px', width: isMobile ? '100%' : '60%' }}>
          <p style={{ fontFamily: 'Raleway', fontSize: 20 }}><i>{sectionInfo?.titles.find((title) => title.titleId === 8)?.titleText ?? ''}</i> {stepParagraphs?.find((paragraph) => paragraph.paragraphId === 9)?.paragraph ?? ''}</p>
        </Row>
        <Column styles={{ margin: isMobile ? '20px auto ' : '20px 0px', width: isMobile ? '100%' : '60%' }}>
          <Typography variant='h2'>{sectionInfo?.titles.find((title) => title.titleId === 9)?.titleText ?? ''}</Typography>
          <Typography size={20}>{stepParagraphs?.find((paragraph) => paragraph.paragraphId === 10)?.paragraph ?? ''}</Typography>
        </Column>
      </Column>
    </ResponsiveContainer>
  )
}
